import api from '@/logic/api'
import { relaunchApi } from '@/logic/relaunchApi'

export default {
  getNews: () => relaunchApi.get('/news'),
  findNewsEntry: (id) => api.get(`/news/${id}`),
  storeNewsView: (id) => api.post('/view/news', { id }),
}
